$(document).ready(function() {

    if ($(".ttgMagazinAnregungList").length) {

        // Sortierung in PHP verschoben

        $(".ttgMagazinAnregungList").fadeTo("slow", 1);

        // Weiterlesen-Funktionalität
        var heightListItem = 0;

        if ($(window).width() < 1170) {
            heightListItem = getHeightOfFirstThreeListItems();
        } else {
            heightListItem = $(".ttgMagazinAnregungList li:first-child").height() + 1;
        }

        // READMORE.JS V3
        new Readmore('.ttgMagazinAnregungList', {
            speed: 650,
            collapsedHeight: heightListItem,
            blockCSS: 'display: flex;',
            moreLink: '<a class="ttgMagazinButton ttgColoredButton" href="#">' + $(".ttgMagazinAnregungList").attr("data-mehrideen") + '</a>',
            lessLink: '<a class="ttgMagazinReadLessLink" href="#"></a>',
            afterToggle: function(trigger, element, expanded) {
                if (expanded) {
                    //remove height because it is sometimes calculated wrong
                    $(".ttgMagazinAnregungList").css("height", "auto");
                }
            }
        });
    }

});

function getHeightOfFirstThreeListItems() {
    var heightFirstListItem = $(".ttgMagazinAnregungList li:eq(1)").height() + 8;
    var heightSecondListItem = $(".ttgMagazinAnregungList li:eq(2)").height() + 8;
    var heightThirdListItem = $(".ttgMagazinAnregungList li:eq(3)").height();
    var heightOfFirstThreeListItems = heightFirstListItem + heightSecondListItem + heightThirdListItem;
    return heightOfFirstThreeListItems;
}